import { MapPin, Navigation } from "lucide-react";
import { COUNTRIES } from "@/lib/currency";
import { useT } from "@/lib/i18n";

export const RestaurantAddress = ({ restaurant, accent, className = "" }) => {
  const { t } = useT();
  if (!restaurant?.address?.trim()) return null;
  const country = COUNTRIES.find((c) => c.code === restaurant.country)?.name;
  const query = [restaurant.name, restaurant.address, country].filter(Boolean).join(", ");
  const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

  return (
    <div data-testid="restaurant-address" className={`bg-white rounded-2xl border border-[#E6E1DA] p-4 flex items-center gap-3 ${className}`}>
      <div className="h-10 w-10 rounded-full grid place-items-center shrink-0" style={{ backgroundColor: `${accent}1A` }}>
        <MapPin className="h-5 w-5" style={{ color: accent }} />
      </div>
      <p data-testid="restaurant-address-text" className="flex-1 min-w-0 text-sm text-[#1F1D1B] leading-snug">{restaurant.address}</p>
      <a data-testid="get-directions-link" href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 shrink-0 rounded-full px-3.5 py-2 text-xs font-semibold text-white transition-transform active:scale-95" style={{ backgroundColor: accent }}>
        <Navigation className="h-3.5 w-3.5" /> {t("getDirections")}
      </a>
    </div>
  );
};
